import level from './level'
import trialEndsAt from './trial-ends-at'
import currentPeriodEndsAt from './current-period-ends-at'
import quantity from './quantity'

const subscriptions = {
    level: Object.assign(level, level),
    trialEndsAt: Object.assign(trialEndsAt, trialEndsAt),
    currentPeriodEndsAt: Object.assign(currentPeriodEndsAt, currentPeriodEndsAt),
    quantity: Object.assign(quantity, quantity),
}

export default subscriptions